import { Header } from "../../components/Header";

export const Cart = () => {
  return (
    <>
      <Header />
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <p
          style={{ margin: "30px auto", textAlign: "center", color: "#a4a4a4" }}
        >
          Cart is Empty
        </p>
      </div>
    </>
  );
};
